import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CreateListTitleComponent } from './create-list-title/create-list-title.component';
import { EditListTitleComponent } from './edit-list-title/edit-list-title.component';
import { ListTitleService } from '../services/list-title.service';

@Component({
  selector: 'app-list-title',
  templateUrl: './list-title.component.html',
  styleUrls: ['./list-title.component.css'],
})
export class ListTitleComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: CreateListTitleComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditListTitleComponent;
  code: any;
  setWidth: string = '100%';
  currentUnitCode: any = '00';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: ListTitleService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.currentUnitCode = this.currentUser?.unitCode;
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'Số thứ tự',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'jobTitleId',
        header: 'Mã chức danh',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'jobTitleName',
        header: 'Tên chức danh',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'commissionRate',
        header: 'Tỷ lệ hoa hồng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'notes',
        header: 'Ghi chú',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      unitCode: this.currentUnitCode,
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize,
    };

    this._service
      .getListTitle(model)
      .then((res) => {
        if (res) {
          this.dataSource = res.data;
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editListTile(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
    this.pEdit.showPopup(model);
  }
  deleteListTile(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động nhóm chức danh này')
        .then((res) => {
          if (res) {
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
    this.pCreate.showPopup();
  }
  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
